// extracted by mini-css-extract-plugin
export default {"CountdownText":"InactiveLogout_CountdownText__a+7uT"};